<template>
  <div>

    <!-- IF OFFERS > 6, SHOW PAGES WITH 6 offers EACH -->
    <div 
      class="carousel" 
      v-if="offersCount>6"
      v-observe-visibility="onVisibilityChange"
    >
      <carousel
          ref="carousel"
          :perPage=1
          :navigation-enabled=false
          :pagination-enabled=false
          :autoplay=false
          :loop="true"
          :mouse-drag="false"
          :touch-drag="false"
          :class="conditionalClasses"
          :key="carouselKey"
      >

        <slide v-for="(chunk,i) in chunkedOffers" :key="chunk.offerCode">
          <OffersContainer :offers="chunkedOffers[i]" :globalPosition="i * 6"/>
        </slide>

      </carousel>

      <div class="custom_controls" :class="conditionalClasses">

        <div class="nav-controls">
          <div @click="prevSlide"
               @keydown.enter="prevSlide"
               @keydown.space.prevent="prevSlide"
               class="navBtn left"
               tabindex="0"
               role="button"
               :aria-label="content.previousOfferPage" />

          <div class="pagination-dots">
        <span
            v-for="(slide,i) in chunkedOffers"
            :key="i"
            :class="{active: i===currentSlide,'not-last-dot': i !== offers.length-1}"
            title=""
            :aria-label="'Slide' + (i+1)"
            @click="goToSlide(i)"
        ></span>
          </div>

          <div @click="nextSlide"
               @keydown.enter="nextSlide"
               @keydown.space.prevent="nextSlide"
               class="navBtn right"
               tabindex="0"
               role="button"
               :aria-label="content.nextOfferPage" />
        </div>
      </div>

    </div>


    <!-- IF OFFERS <=6 -->
    <OffersContainer :offers="offers" :globalPosition="0" v-else />
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import OffersContainer from "@/features/offers/OffersContainer.vue";
import {mapGetters} from "vuex";

export default {
  components:{OffersContainer, Carousel, Slide},
  data(){
    return{
      currentSlide:0,
      carouselKey:0
    }
  },
  methods:{
    prevSlide(){
      this.currentSlide = this.currentSlide === 0 ? this.chunkedOffers.length-1  : this.currentSlide-1
      this.goToSlide(this.currentSlide)
    },
    nextSlide(){
      this.currentSlide = this.currentSlide === this.chunkedOffers.length-1 ? 0 : this.currentSlide+1
      this.goToSlide(this.currentSlide)
    },
    goToSlide(index){
      this.currentSlide = index
      this.$refs.carousel.goToPage(index)
    },
    updateCarouselKey(){
      //this was added to force carousel component to remount when flyer orientation changes. This solves the issue of carousel slide getting cut off.
      this.carouselKey++;
    },
    onVisibilityChange(isVisible) {
      if (isVisible && this.offersCount > 6) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.carousel) {
              const carouselInner = this.$refs.carousel.$el?.querySelector('.VueCarousel-inner');
              if (carouselInner) {
                if (this.$refs.carousel.computeCarouselWidth) {
                  this.$refs.carousel.computeCarouselWidth();
                }
              }
            }
          }, 100);
        });
      }
    }
  },
  computed: {
    ...mapGetters(['content']),
    ...mapGetters('screen',['displayMode','flyerOrientation']),
    ...mapGetters('ctOffersUser',['offers']),
    conditionalClasses(){
      this.updateCarouselKey()
      return{
        'dVertical': this.flyerOrientation==='vertical' && (this.displayMode==='desktop' || this.displayMode==='tablet'),
        'vertical': this.flyerOrientation==='vertical' && this.displayMode==='mobile'
      }
    },
    offersCount() {
      return this.offers.length || 0;
    },
    chunkedOffers(){
      if(this.offers.length > 6){
        const chunkSize = 6;
        return this.offers.reduce((acc, item, index) => {
          const chunkIndex = Math.floor(index/chunkSize);
          if(!acc[chunkIndex])
            acc[chunkIndex] = [];
          acc[chunkIndex].push(item);
          return acc;
        },[]);
      }
      return [];
    }
  }
}
</script>

<style scoped>

.carousel .VueCarousel{
    width:420px;
  }
.carousel .VueCarousel.vertical{
  width:425px;
}
.carousel .VueCarousel.dVertical{
    width:690px;
  }
  .custom_controls {
    position: absolute !important;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 1000;
  }

  .custom_controls .nav-controls {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 44px;
    padding: 9px;
    width: 80%;
  }

  .custom_controls .nav-controls .navBtn {
    border: none;
    border-radius:50%;
    cursor: pointer;
    outline:none;
    height: 30px;
    width: 36px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .custom_controls .nav-controls .navBtn:hover{
    border: 1px solid black;
  }

  .custom_controls .nav-controls .navBtn.left{
    background: url('/images/chevron-left.svg') no-repeat center;
    background-size: contain;
  }
  .custom_controls .nav-controls .navBtn.right{
    background: url('/images/chevron-right.svg') no-repeat center;
    background-size: contain;
  }

    /*button:focus{
      border: 1px solid var(--secondary-color);
    }*/
.custom_controls .nav-controls .pagination-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    pointer-events: none;
  }

.custom_controls .nav-controls .pagination-dots span{
  border: 1px solid rgb(0, 0, 0);
  background: rgb(255, 255, 255,1);
  border-radius: 50%;
  cursor: pointer;
  height: 12px;
  width: 12px;
  margin-top: 7px;
}


.custom_controls .nav-controls .pagination-dots span.active{
  background-color: rgba(0, 0, 0) !important ;
}
.custom_controls .pagination-dots span.not-last-dot{
  margin-right: 1em !important;
}
.custom_controls .pagination-dots span:hover{
  filter: brightness(90%);
}

.custom_controls.dVertical{
  /* bottom:-17px; */
  bottom: 0;
}
.custom_controls.vertical { /*MobileView*/
  bottom: -10px;
}
.VueCarousel-slide {
  visibility: visible;
  flex-basis: 100%;
  width: 100%;
}
</style>